import { Box, BoxProps } from '@mui/material';

import { withSxProp } from 'common/utils/props';

import { Loader } from './Loader';

export const BoxLoader = (props: BoxProps) => (
    <Box
        {...props}
        sx={[
            {
                height: '300px',
                position: 'relative',
            },
            ...withSxProp(props.sx),
        ]}
    >
        <Loader />
    </Box>
);
